/* eslint-disable */
import { defaultApiInstance } from '@/compositions/api';

// params.partnerId — партнёр брони: бэк вернёт справочник этого партнёра + «общие» записи.
export function getContracts(params = {}) {
  return defaultApiInstance.get(`v1/contract`, { params });
}

export function getContract(id) {
  return defaultApiInstance.get(`v1/contract/${id}`);
}

export function createContract(data) {
  return defaultApiInstance.post(`v1/contract/create`, JSON.stringify(data));
}

export function updateContract(id, data) {
  return defaultApiInstance.put(`v1/contract/${id}/update`, JSON.stringify(data));
}

export function deleteContract(id) {
  return defaultApiInstance.delete(`v1/contract/${id}/delete`);
}
